import { render, staticRenderFns } from "./kisaeDataIndex.vue?vue&type=template&id=5231b586"
import script from "./kisaeDataIndex.vue?vue&type=script&lang=js"
export * from "./kisaeDataIndex.vue?vue&type=script&lang=js"
import style0 from "./kisaeDataIndex.vue?vue&type=style&index=0&id=5231b586&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports